import { z } from "zod";
import { IsoDate } from "./primitives";
import { hasRole, type Role } from "./roles"; // rôles réels : packages/shared/src/roles.ts

export const MANQUES = ["empreinte", "teinte", "validation_devis", "radio", "photos", "autre"] as const;
export type ManqueType = (typeof MANQUES)[number];
export const MANQUE_LABELS: Record<ManqueType, string> = {
  empreinte: "Empreinte", teinte: "Teinte", validation_devis: "Validation du devis",
  radio: "Radio", photos: "Photos", autre: "Autre",
};

export const ReveilSchema = z.object({
  n: z.union([z.literal(1), z.literal(2), z.literal(3)]),
  date: IsoDate,
  actionId: z.string().nullable(),
  brouillonId: z.string().nullable(),
});
export type Reveil = z.infer<typeof ReveilSchema>;

export const AttenteSchema = z.object({
  id: z.string(),
  travailCode: z.string(),
  famille: z.string().nullable(),
  manqueType: z.enum(MANQUES),
  manqueTexte: z.string().nullable(),
  livraisonDemandee: IsoDate,
  delaiFabricationJo: z.number().int().min(0),
  depart: IsoDate,
  dernierJour: IsoDate,
  reveils: z.array(ReveilSchema),
  etat: z.enum(["ouverte", "reponse_recue", "annulee"]),
  reponseLe: IsoDate.nullable(),
  nouvelleLivraison: IsoDate.nullable(),
  creePar: z.string(),
  creeLe: z.string(),
});
export type Attente = z.infer<typeof AttenteSchema>;

export const DeclarationAttenteSchema = z.object({
  manqueType: z.enum(MANQUES),
  manqueTexte: z.string().trim().max(500).nullable(),
  livraisonDemandee: IsoDate,
  delaiFabricationJo: z.number().int().min(0).max(120),
}).refine((d) => d.manqueType !== "autre" || (d.manqueTexte ?? "").length > 0, {
  message: "Préciser ce qui manque quand le choix est « Autre »", path: ["manqueTexte"],
});
export type DeclarationAttente = z.infer<typeof DeclarationAttenteSchema>;

export const ROLES_ATTENTE: readonly Role[] = ["admin", "secretariat"];
/** L'idiome du dépôt (`roles.ts:38`), jamais un `some` réécrit : une seule règle. */
export function canDeclarerAttente(roles: readonly Role[]): boolean {
  return hasRole(roles, ...ROLES_ATTENTE);
}
